import React from 'react';
import MasterLayout from '../masterLayout/MasterLayout';
import TechniciansLayer from '../components/TechniciansLayer';

const TechniciansPage = () => {
  return (
    <>
      <MasterLayout pageTitle="Technicians">
        <TechniciansLayer />
      </MasterLayout>
    </>
  );
};

export default TechniciansPage;
